module.exports = __webpack_public_path__ + "static/banner-placements-desktop-acbe618c0a67385766d6a6004fe0a7b1.jpg";